<template>
  <div class="row mb-5 checkbox">
    <label class="col-md-6 col-lg-4 fw-bold" :for="id">{{ text }}</label>
    <div class="col-md-6 col-lg-8">
      <input
          type="checkbox"
          :id="id"
          :name="id"
          :checked="value"
          @change="$emit('input', $event.target.checked)"
      >
    </div>
  </div>
</template>

<script>
export default {
  props: {
    id: String,
    text: String,
    value: Boolean
  }
}
</script>

<style lang="scss" scoped>

.checkbox {
  input[type="checkbox"] {
    cursor: pointer;
    position: relative;
    z-index: 1;
    appearance: none;
    background-color: #fff;
    margin: 0;
    font: inherit;
    color: currentColor;
    border: 1px solid $grey-darker;
    border-radius: 0.25rem;
    transform: translateY(-0.075em);
    display: grid;
    place-content: center;
    width: 26px;
    height: 26px;


    &::before {
      content: "";
      width: 15px;
      height: 15px;
      transform: scale(0);
      transition: 120ms transform ease-in-out;
      box-shadow: inset 1em 1em $green;
      clip-path: polygon(20% 0,0 20%,30% 50%,0 80%,20% 100%,50% 70%,80% 100%,100% 80%,70% 50%,100% 20%,80% 0,50% 30%);
    }
  }

  &.checked {
    input[type="checkbox"]::before {
      transform: scale(1);
    }
  }
}
</style>